import gql from "graphql-tag";

export default gql`
  query GetCompanyTechnicians($id: ID!) {
    allUsers(
      filter: {
        company: { id: $id }
        isATechnician: true
        emailVerified: true
        disabled: false
      }
    ) {
      id
      email
      firstName
      lastName
      role
      phoneNumber
      jobTitle
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyTechnicians.ts